import { OrderOddsType } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const betOrderOddsTypeDictionary = createSimpleDictionary([
    { id: OrderOddsType.Best, name: 'dictionaries.orderOddsType.bestOdds' },
    { id: OrderOddsType.Median, name: 'dictionaries.orderOddsType.medianOdds' },
    { id: OrderOddsType.Lowest, name: 'dictionaries.orderOddsType.lowestOdds' },
]);
